<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> Chiffrement </div>
        <div class="modal-body">
            <div class="explain">                
                <p>Vous pouvez choisir d'utiliser les informations du patient source (fiche patient actuelle)<br>ou du patient cible (patient recherché).</p>
            </div>

            <div class="form-wrapper">
                <form [formGroup]="formGroup">

                    <div class="wrapper">

                        <div class="infos">Patient<br>source</div>
    
                        <div class="radio-buttons-wrapper">
    
                            <mat-radio-group formControlName="nom" aria-label="Sélectionner un nom">
                                <mat-radio-button labelPosition="before" [value]="fusionConfigEnum.SOURCE">{{ sourcePatient.nom }}</mat-radio-button>
                                <mat-radio-button [value]="fusionConfigEnum.TARGET">{{ targetPatient.nom }}</mat-radio-button>
                            </mat-radio-group>
        
                            <mat-radio-group formControlName="prenom" aria-label="Sélectionnez un prénom">
                                <mat-radio-button labelPosition="before" [value]="fusionConfigEnum.SOURCE">{{ sourcePatient.prenom }}</mat-radio-button>
                                <mat-radio-button [value]="fusionConfigEnum.TARGET">{{ targetPatient.prenom }}</mat-radio-button>
                            </mat-radio-group>
        
                            <mat-radio-group formControlName="dateNaissance" aria-label="Sélectionnez une date de naissance">
                                <mat-radio-button labelPosition="before" [value]="fusionConfigEnum.SOURCE">{{ sourcePatient.dateNaissance }}</mat-radio-button>
                                <mat-radio-button [value]="fusionConfigEnum.TARGET">{{ targetPatient.dateNaissance }}</mat-radio-button>
                            </mat-radio-group>
        
                            <mat-radio-group formControlName="sexe" aria-label="Sélectionnez un sexe">
                                <mat-radio-button labelPosition="before" [value]="fusionConfigEnum.SOURCE">{{ sourcePatient.sexe }}</mat-radio-button>
                                <mat-radio-button [value]="fusionConfigEnum.TARGET">{{ targetPatient.sexe }}</mat-radio-button>
                            </mat-radio-group>
        
                        </div>
    
                        <div class="infos">Patient<br>cible</div>
        
                    </div>

                    <div class="button-wrapper">
                        <frg-button (activated)="cancel()">Annuler</frg-button>
                        <frg-button (activated)="validFusionConfig()">Valider</frg-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>
